module.exports = __webpack_public_path__ + "img/flag_nl.9e201f80.svg";